import { useEffect, useRef } from "react";
import { isEmpty } from "lodash";
import useClientMetrics from "../../hooks/useClientMetrics.js";
const useWishlistWidgetTracking = ({ component, isLoading, error }) => {
    const { trackClientMetric } = useClientMetrics();
    const hasTrackedRef = useRef(false);
    useEffect(() => {
        if (isLoading || hasTrackedRef.current)
            return;
        if (error && !isEmpty(error)) {
            trackClientMetric("js_wishlist_widget_load_failed");
            hasTrackedRef.current = true;
            return;
        }
        if (!component) {
            trackClientMetric("js_wishlist_widget_load_failed");
            hasTrackedRef.current = true;
            return;
        }
        trackClientMetric("js_wishlist_widget_load_success");
        hasTrackedRef.current = true;
    }, [component, isLoading, error, trackClientMetric]);
};
export default useWishlistWidgetTracking;
